<template>
    <div v-if="loading" class="floating-center">
        <div class="floating-center__inner">
            <b-spinner></b-spinner>
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FloatingCenterSpinner',
    props: {
        loading: {},
    },
};
</script>
<style scoped lang="scss">
.floating-center {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    z-index: 300;

    &__inner {
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        gap: 16px;

        .spinner-border {
            margin: auto;
        }
    }
}
</style>
